import { apiRequest } from "../apiRequest";

export async function logout() {
  await apiRequest({ url: "auth/logout", method: "POST" });
  // force a reload
  window.location.href = "/";
}
